import { useMediaQuery } from './useMediaQuery';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

/**
 * prefers-reduced-motion 미디어 쿼리를 감지하는 훅
 * 저사양 디바이스나 사용자가 모션 감소를 선호하는 경우 true 반환
 */
export const useReducedMotion = () => useMediaQuery(REDUCED_MOTION_QUERY);
